// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1Ie_N","header":"MergedInvoice_header___6CIc"};